import { c as r, cB as i, cE as n, cM as o } from "../../../_utils/cssr/index.js";
import { repeat as p } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
const a = p(24, null).map((s, l) => {
  const t = l + 1, e = `calc(100% / 24 * ${t})`;
  return [o(`${t}-span`, {
    width: e
  }), o(`${t}-offset`, {
    marginLeft: e
  }), o(`${t}-push`, {
    left: e
  }), o(`${t}-pull`, {
    right: e
  })];
}), f = r([i("row", {
  width: "100%",
  display: "flex",
  flexWrap: "wrap"
}), i("col", {
  verticalAlign: "top",
  boxSizing: "border-box",
  display: "inline-block",
  position: "relative",
  zIndex: "auto"
}, [n("box", {
  position: "relative",
  zIndex: "auto",
  width: "100%",
  height: "100%"
}), a])]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/legacy-grid/src/styles/index.cssr.js
// module id = 1706
// module chunks = 67